import { parseBigintRouteParam } from '@client/utils/routing/parse-bigint-route-param';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

// Attribution is optional: discard unknown keys and invalid values without
// preventing an otherwise valid legacy link from reaching the complaint form.
const complaintSearchSchema = z.object({
    source: z.string().max(200).optional().catch(undefined),
    utm_source: z.string().max(200).optional().catch(undefined),
    utm_campaign: z.string().max(200).optional().catch(undefined),
    utm_medium: z.string().max(200).optional().catch(undefined),
});

// Legacy public complaint URL. Redirect at the router level rather than rendering
// `<Navigate>` (docs/guidelines/client-patterns.md → "Index Route Redirects"); a non-numeric org
// segment is a 404 rather than a BigInt SyntaxError for Sentry.
export const Route = createFileRoute('/public/new-complaint/$orgId')({
    validateSearch: zodValidator(complaintSearchSchema),
    params: {
        parse: (params) => ({ orgId: parseBigintRouteParam(params.orgId) }),
    },
    beforeLoad: ({ params, search: incomingSearch }): never => {
        // Router search also includes unvalidated parent keys; strip them at the
        // redirect boundary rather than relying on validateSearch's inferred type.
        const search = complaintSearchSchema.parse(incomingSearch);
        throw redirect({
            to: '/public/$orgId/complaint/new',
            params,
            // Reset the root search field while forwarding only validated attribution.
            search: { ...search, search: undefined },
            replace: true,
        });
    },
});
